export interface Route { name: "home" | "login" | "projects" | "new" | "ai" | "library" | "settings" | "editor" | "notfound"; id?: string; query: URLSearchParams }
export function parseRoute(pathname: string, search = ""): Route {
  const query = new URLSearchParams(search);
  const parts = pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  const [a, b] = parts;
  if (parts.length === 0) return { name: "home", query };
  if (parts.length === 1 && ["login", "projects", "new", "ai", "library", "settings"].includes(a!)) return { name: a as Route["name"], query };
  if (a === "editor" && b && parts.length === 2) return { name: "editor", id: decodeURIComponent(b), query };
  return { name: "notfound", query };
}
/** Only same-origin absolute paths are allowed as post-login redirects (prevents open redirects). */
export function safeNext(next: string | null): string {
  return next && /^\/(?!\/)[A-Za-z0-9/_\-?=&.%]*$/.test(next) ? next : "/";
}
